import { render, staticRenderFns } from "./IspOrganisationView.vue?vue&type=template&id=fad41896&"
import script from "./IspOrganisationView.vue?vue&type=script&lang=js&"
export * from "./IspOrganisationView.vue?vue&type=script&lang=js&"
import style0 from "./IspOrganisationView.vue?vue&type=style&index=0&id=fad41896&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports